import { SelectField } from "$components/inputs";
import { Divider, MenuItem } from "@material-ui/core";
import { InventoryMoveRequestStatus } from "elephant-web/gql";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface Props {
  value: InventoryMoveRequestStatus | null;
  onChange: (locationId: InventoryMoveRequestStatus | null) => void;
}

const all = "ALL";

const StatusSelect: FC<Props> = ({ value, onChange }) => {
  const { formatMessage } = useIntl();
  return (
    <SelectField
      name="location"
      id="move-request-status-select"
      fullWidth
      hideHelper
      label={formatMessage({
        id: "inventory.moveRequests.statusSelect.placeholder",
        defaultMessage: "Show Requests",
      })}
      selectProps={{
        value: value || all, // selecting the default value doesn't work will with 'null'

        onChange: (
          e: React.ChangeEvent<{
            value: InventoryMoveRequestStatus | typeof all;
          }>,
        ) => {
          const newValue = e.target.value;
          onChange(newValue === all ? null : newValue);
        },
      }}
    >
      <MenuItem value={InventoryMoveRequestStatus.Fulfilled}>
        <FormattedMessage
          id="inventory.overview.locationSelect.fulfilledOption"
          defaultMessage="Fulfilled"
        />
      </MenuItem>
      <MenuItem value={InventoryMoveRequestStatus.Pending}>
        <FormattedMessage
          id="inventory.overview.locationSelect.pendingOption"
          defaultMessage="Pending"
        />
      </MenuItem>
      <MenuItem value={InventoryMoveRequestStatus.Rejected}>
        <FormattedMessage
          id="inventory.overview.locationSelect.rejectedOption"
          defaultMessage="Rejected"
        />
      </MenuItem>
      <Divider />
      <MenuItem value={all}>
        <FormattedMessage
          id="inventory.overview.locationSelect.allRequestsOption"
          defaultMessage="All"
        />
      </MenuItem>
    </SelectField>
  );
};

export default StatusSelect;
